import { useState, useEffect } from "react";
import { Input } from "@material-ui/core";

interface ITaskSearchBarProps {
    onNewFilterText: ((newFilterText: string) => void);
}

export const TaskSearchBar = (props: ITaskSearchBarProps) => {
    const [filterText, setFilterText] = useState<string>('');

    useEffect(() => {
        const debounceTimeout = setTimeout(() => props.onNewFilterText(filterText), 1000);
        const destructor = () => clearTimeout(debounceTimeout);
        return destructor
    }, [filterText]);

    return (
        <div>
            <Input onChange={(e) => setFilterText(e.target.value)} placeholder="Search" />
        </div>
    )
}